import { gql } from '@apollo/client';

export const GET_USER_PORTFOLIOS = gql`
  query GET_USER_PORTFOLIOS($userId: Int!) {
    getUserPortfolios(userId: $userId) {
      id
      userId
      image
      title
      description
      videoUrl
      genres
      teamMembers
      url
      createdAt
    }
  }
`;
